import { MantineTheme, createTheme } from "@mantine/core";
import type { PartialDeep } from "type-fest";

const theme: PartialDeep<MantineTheme> = createTheme({
  white: "#FFFFFF",
  black: "#1E1E1E",
  fontFamily: "Inter",
  headings: {
    fontFamily: "Inter",
    fontWeight: "Bold",
    sizes: {
      h1: {
        fontSize: "24",
        fontWeight: "Bold",
      },
      h2: {
        fontSize: "20",
        fontWeight: "Bold",
      },
    },
  },
  primaryColor: "grape",
  primaryShade: 4,
  colors: {
    grape: [
      "#E5C5FF", // Purple 01
      "#D4AEF6",
      "#C397EC", // Purple 04
      "#CB8BFF", // Purple 02
      "#BD6DFF", // Purple 03
      "#AC5FF0",
      "#9B51E0", // Purple 05
      "#914AE7",
      "#8642EE",
      "#7033FC", // Purple 06
    ],
    gray: [
      "#FBFBFB",
      "#F7F7F7", // Gray 05
      "#ECECE8", // Gray 04
      "#BDBDBD", // Gray 03
      "#A9A0B2", // Gray 01
      "#959099",
      "#7B7580", // Gray 02
      "#5A575C",
      "#3C3B3D",
      "#262626",
    ],
  },
});

export default theme;
